import {api} from "./api";

export const UniversalFilter = () => {
    return {
        search: '',
        categories: [],
        init() {
            this.$watch('search', (value) => {
                api.post(
                    `custom/search/universalSearch`,
                    `search=${value}`
                ).then(async (response) => {
                    this.categories = await response
                })
            })
        }
    }
}